import styled from '@themes/theme'

export const MoneyInfoWrap = styled.ul`
  display: flex;
  flex-flow: column;
  width: 100%;
  background-color: ${props=>props.theme.color.themeTxt};
  .info-list {
    display: flex;
    align-items: center;
    margin: 0 25px;
    padding: 18px;
    height: 100%;
    border-bottom: 1px solid ${props => props.theme.color.modalBg};
    svg {
      width: 33px;
    }
    .info-txt {
      color: ${props=>props.theme.color.modalTxt};
      font-weight: ${props=>props.theme.fontW.bold};
      font-size: ${props=>props.theme.font.large};
      text-align: left;
      margin-left: 24px;
      &--label {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: ${props=>props.theme.font.medium};
        background-color: ${props=>props.theme.color.subBg};
        color: ${props=>props.theme.color.themeTxt};
        border-radius: 100px;
        padding: 1px 13px;
        margin-bottom: 5px;
      }
      .sub-txt {
        color: ${props=>props.theme.color.modalgray};
        font-weight: ${props=>props.theme.fontW.medium};
      }
    }
  }
`
